import { defineMessages, MessageDescriptor } from 'react-intl';
import { MemriseApiError } from 'src/api';
import { CompactUser } from 'src/context/user';
import { PremiumConfig } from 'src/api/internal/schema';

export const msgs = defineMessages({
  alreadyPro: { id: 'web_plans_proalready_1' },
  unexpectedError: { id: 'payment_page_ccform_error_othererror' },
});

export function getUpsellPageErrorInfo({
  user,
  premiumConfig,
  premiumConfigError,
  subscribeError,
}: {
  user: CompactUser | null;
  premiumConfig: PremiumConfig | null | undefined;
  premiumConfigError: unknown;
  subscribeError: unknown;
}) {
  const premiumConfigErrorInfo = premiumConfigError ? tryGetErrorInfo(premiumConfigError) : null;
  const emptyPricesErrorInfo =
    premiumConfig && premiumConfig.prices.length === 0
      ? {
          descriptionMsg: msgs.unexpectedError,
          code: 'NO_PRICES',
        }
      : null;
  const subscribeErrorInfo = subscribeError ? tryGetErrorInfo(subscribeError) : null;
  const showAlreadyProModal = Boolean(user?.isPro) || subscribeErrorInfo?.code === 'ALREADY_PRO';

  return {
    fullPageError: showAlreadyProModal
      ? null
      : premiumConfigErrorInfo || emptyPricesErrorInfo || subscribeErrorInfo,
    showAlreadyProModal,
  };
}

export function tryGetErrorInfo(e: unknown): {
  descriptionMsg: MessageDescriptor;
  code?: string;
} {
  if (e instanceof Error) {
    if (e.message === 'Required promotion code is not present') {
      return {
        descriptionMsg: msgs.unexpectedError,
        code: 'NO_REQUIRED_PROMO_CODE',
      };
    }
  }

  if (!(e instanceof MemriseApiError)) {
    return {
      descriptionMsg: msgs.unexpectedError,
    };
  }

  const { httpStatusCode, code, message } = e as MemriseApiError;

  if (httpStatusCode === 409) {
    return {
      descriptionMsg: msgs.alreadyPro,
      code: 'ALREADY_PRO',
    };
  }

  if (message.includes('No such price')) {
    return {
      descriptionMsg: msgs.unexpectedError,
      code: 'INCORRECT_PRICE',
    };
  }

  if (message.includes('No such promotion code')) {
    return {
      descriptionMsg: msgs.unexpectedError,
      code: 'INCORRECT_PROMO_CODE',
    };
  }

  if (message.includes('No such coupon')) {
    return {
      descriptionMsg: msgs.unexpectedError,
      code: 'INCORRECT_COUPON',
    };
  }

  return {
    descriptionMsg: msgs.unexpectedError,
    code: `${httpStatusCode} (${code})`,
  };
}
